import { CodeLanguageTokens } from './language.token'
import { CodeLanguageTypescript } from './language.typescript'

const store = {
  token: CodeLanguageTokens,
  typescript: CodeLanguageTypescript,
}

export type LanguageKey = keyof typeof store

export const applyLanguageBefore = (
  monaco,
  key: string,
  configuration?: any,
) => {
  const language = store[key]

  if (language?.onBefore && monaco) {
    language.onBefore(monaco, configuration)
  }
}

export const applyLanguageAfter = (
  editor,
  monaco,
  key: string,
  configuration?: any,
) => {
  const language = store[key]

  if (language?.onAfter && editor && monaco) {
    language.onAfter(editor, monaco, configuration)
  }
}
